export const insertNewFileOrFolder = (root, folder, newItem) => {
  if (root.id === folder.id) {
    root.items.push({ ...newItem });
    return root;
  }

  if (Array.isArray(root)) {
    root.forEach((item) => insertNewFileOrFolder(item, folder, newItem));
  }
  let updatedExplorerData = root?.items?.map((obj) => insertNewFileOrFolder(obj, folder, newItem));

  if (Array.isArray(root)) {
    return [...root];
  } else {
    return {
      ...root,
      items: updatedExplorerData ? [...updatedExplorerData] : []
    };
  }
};

export const deleteFolderOfFile = (root, folder) => {
  if (root.id === folder.id) {
    return {};
  }

  let temp = [];
  if (Array.isArray(root)) {
    root.forEach((item) => temp.push(deleteFolderOfFile(item, folder)));
  }

  let updatedExplorerData = root?.items?.map((obj) => deleteFolderOfFile(obj, folder));
  if (Array.isArray(root)) {
    return [...temp];
  } else {
    return {
      ...root,
      items: updatedExplorerData ? [...updatedExplorerData] : []
    };
  }
};

export const editFolderOrFile = (root, folder, newName) => {
  if (root.id === folder.id) {
    return { ...root, name: newName };
  }
  let temp = [];
  if (Array.isArray(root)) {
    root.forEach((item) => temp.push(editFolderOrFile(item, folder, newName)));
  }
  let updatedExplorerData = root?.items?.map((obj) => editFolderOrFile(obj, folder, newName));
  if (Array.isArray(root)) {
    return [...temp];
  } else {
    return {
      ...root,
      items: updatedExplorerData ? [...updatedExplorerData] : []
    };
  }
};

export const getFolderFileById = (data, id) => {
  for (const item of data) {
    if (item.id === id) {
      return item; // Found the object with the matching id
    }

    if (!item.isFolder) {
      continue; // Skip objects with isFolder set to true
    }

    if (item.items && item.items.length > 0) {
      const result = getFolderFileById(item.items, id);
      if (result) {
        return result; // Object found in the nested items
      }
    }
  }

  return null; // Object with the specified id not found
};

export const collapseFolder = (data, openType) => {
  const updateFolder = data.map((folder) => {
    if (folder.isFolder) {
      const folderItems = collapseFolder(folder.items, openType);
      folder.items = folderItems;
      return { ...folder, isOpen: openType };
    } else {
      return folder;
    }
  });
  return updateFolder;
};
